import {
  foundationTheme,
  ThemeColorPath,
  ThemeRadiusPath,
  ThemeShadowsPath,
} from 'platform/foundation';

type ChoiceTheme = {
  backgroundColor: ThemeColorPath;
};

const Choice: ChoiceTheme = {
  backgroundColor: 'palettes.neutral.900.100',
};

type CardTheme = {
  elevation: ThemeShadowsPath;
  borderRadius: ThemeRadiusPath;
};

const Card: CardTheme = {
  elevation: 'elevation_1',
  borderRadius: 'small',
};

type SwitchTheme = {
  trackStyle: {backgroundColor: string};
};

const Switch: SwitchTheme = {
  trackStyle: {backgroundColor: foundationTheme.colors.palettes.neutral[200][100]},
};

type ButtonTheme = {
  variants: {
    ghost: {hover: {backgroundColor: string}; active: {backgroundColor: string}};
    link: {color: string};
  };
};

const Button: ButtonTheme = {
  variants: {
    ghost: {
      hover: {backgroundColor: foundationTheme.colors.palettes.neutral[30][100]},
      active: {backgroundColor: foundationTheme.colors.palettes.neutral[40][100]},
    },
    link: {color: foundationTheme.colors.text.link},
  },
};

const htmlStyle: {overflowX: string} = {
  overflowX: 'hidden',
};

export const componentsTheme = {
  ...foundationTheme,
  config: {
    cssVarPrefix: 'eag',
  },
  styles: {
    global: {
      html: {
        ...htmlStyle,
      },
    },
  },
  components: {
    ...foundationTheme.components,
    Card,
    Button,
    Choice,
    Switch,
    Table: {},
    Status: {},
    Password: {},
    Form: {},
  },
} as const;

export type DefaultComponentsTheme = typeof componentsTheme;
